// extracted by mini-css-extract-plugin
export var anchor = "_34-0";
export var discard = "_34-4";
export var muiTooltipTooltip = "_34-6";
export var notificationBar = "_34-3";
export var saveButtonHoverSlotWrapper = "_34-5";
export var show = "_34-2";
export var spacer = "_34-1";